import React from 'react';
import { get } from 'lodash';
import { BasicForm } from './BasicForm.jsx';
import { FormLabel } from '../FormLabel.jsx';
import { FormErrorMessage } from '../FormErrorMessage.jsx';

import * as phone_number from '../../../../../../utils/phone_number';

const checkCodeTimeout = 750;

export class PhoneNumberSeparateForm extends BasicForm {
  areaCodeRef = null;
  cityCodeRef = null;
  subscriberNumberRef = null;

  componentDidMount () {
    // Need to manually check initial_value to mark field touched
    // so that error message will be displayed even if these fields
    // with initial_value had not been touched by user.
    this.checkValuesToTouch();
  }

  checkValuesToTouch () {
    const { touch, nameMap } = this.props;

    if (this.areaCode.input.value) {
      touch(nameMap.areaCode);
    }
    if (this.cityCode.input.value) {
      touch(nameMap.cityCode);
    }
    if (this.subscriberNumber.input.value) {
      touch(nameMap.subscriberNumber);
    }
  }

  // automatic focus-forward is disabled for brevity
  // https://www.pivotaltracker.com/story/show/173464349
  //
  // handleAreaCodeChange = (...args) => {
  //   this.areaCode.input.onChange(...args);
  //   this.debounced_checkAreaCode();
  // };
  //
  // checkAreaCode = () => {
  //   const value = this.areaCode.input.value;
  //   if (phone_number.isValidHead(value)) {
  //     this.cityCodeRef.focus();
  //   }
  // };
  //
  // debounced_checkAreaCode = debounce(this.checkAreaCode, checkCodeTimeout);
  //
  // handleCityCodeChange = (...args) => {
  //   this.cityCode.input.onChange(...args);
  //   this.debounced_checkCityCode();
  // };
  //
  // checkCityCode = () => {
  //   const areaCodeValue = this.areaCode.input.value;
  //   const value = this.cityCode.input.value;
  //   if (phone_number.isValidBody(areaCodeValue, value)) {
  //     this.subscriberNumberRef.focus();
  //   }
  // };
  //
  // debounced_checkCityCode = debounce(this.checkCityCode, checkCodeTimeout);

  render () {
    const {
      object,
      disabled,
    } = this.props;

    const { areaCode, cityCode, subscriberNumber } = this;

    const error = areaCode.meta.error || cityCode.meta.error || subscriberNumber.meta.error;
    const touched = areaCode.meta.touched && cityCode.meta.touched && subscriberNumber.meta.touched;
    const valid = areaCode.meta.valid && areaCode.meta.valid && subscriberNumber.meta.valid;

    const inputProps = {
      disabled,
      className: 'cu-ui-input',
      type: 'tel',
    };

    return (
      <div ref={el => this.cont = el} className="cu-ui-form-group">
        <FormLabel
          valid={valid}
          label={object.label}
          required={object.validations.required}
        />
        <div className="cu-ui-phone-number-separate">
          <input
            { ...inputProps }
            { ...areaCode.input }
            data-testid="areaCodeInput"
            ref={el => this.areaCodeRef = el}
            placeholder={get(object, 'data.area_code.placeholder', '')}
            onFocus={this.handleFocusInput(this.areaCode.input.onFocus)}
            onBlur={this.handleBlurInput(this.areaCode.input.onBlur)}
            maxLength={4}
          />
          <div className="cu-ui-phone-number-separate__separator"/>
          <input
            { ...inputProps }
            { ...cityCode.input }
            data-testid="cityCodeInput"
            ref={el => this.cityCodeRef = el}
            placeholder={get(object, 'data.city_code.placeholder', '')}
            onFocus={this.handleFocusInput(this.cityCode.input.onFocus)}
            onBlur={this.handleBlurInput(this.cityCode.input.onBlur)}
            maxLength={4}
          />
          <div className="cu-ui-phone-number-separate__separator"/>
          <input
            { ...inputProps }
            { ...subscriberNumber.input }
            data-testid="subscriberNumberInput"
            ref={el => this.subscriberNumberRef = el}
            placeholder={get(object, 'data.subscriber_number.placeholder', '')}
            onFocus={this.handleFocusInput(this.subscriberNumber.input.onFocus)}
            onBlur={this.handleBlurInput(this.subscriberNumber.input.onBlur)}
            maxLength={4}
          />
        </div>
        <FormErrorMessage
          error={error}
          touched={touched}
        />
      </div>
    );
  }

  get areaCode () {
    return this.props[this.props.nameMap.areaCode];
  }

  get cityCode () {
    return this.props[this.props.nameMap.cityCode];
  }

  get subscriberNumber () {
    return this.props[this.props.nameMap.subscriberNumber];
  }
}
